// pages/TopMarketCap.js
import React, { useState, useEffect } from 'react';
import HomeFilter from './HomeFilter';
import FilterNav from './FilterNav';

const apiUrl = process.env.REACT_APP_API_URL;

const TopMarketCap = () => {
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTopMarketCap = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/coins/top-market-cap`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        const data = await response.json();
        setCoins(data);
        setError(null);
      } catch (error) {
        console.error('Error fetching top market cap coins:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopMarketCap();
  }, []);

  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
      <div className="home_wrapper">
        <HomeFilter coins={coins} />
      </div>
  );
};

export default TopMarketCap;